<template>
  <Head title="Login" />
  <div class="min-h-screen bg-blue-900 grid grid-cols-1 md:grid-cols-2">
    <div class="flex items-center justify-center">
      <img src="/images/logo_home.png" width="246" height="316">
    </div>
    <div class="flex items-center justify-center bg-white rounded-t-lg md:rounded-none md:rounded-l-lg min-h-full">
      <form class="mt-1 w-full max-w-lg" @submit.prevent="login">
        <div class="py-12 px-10 md:px-0">
          <h1 class="text-center text-3xl font-bold">MyHeart - Painel</h1>
          <div class="mt-6 mx-auto w-24 border-b-2" />
          <text-input v-model="form.email" :error="form.errors.email" class="mt-10" label="E-mail" type="email" autofocus autocapitalize="off" />
          <password-input v-model="form.password" :error="form.errors.password" class="mt-6" label="Senha" />
          <loading-button :loading="form.processing" class="btn-blue w-full mt-6 justify-center" type="submit">Login</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import PasswordInput from '@/Shared/PasswordInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,
    Logo,
    TextInput,
    PasswordInput,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: 'admin@cebras.com.br',
        password: '123456',
        remember: false,
      }),
    }
  },
  methods: {
    login() {
      this.form.post('/login')
    },
  },
}
</script>
